//What a booking's question answers say, as text: shared by the scanned-booking dialog on At a
//Glance and the AI staff assistant, so both read answers the same way.

//Every booking question that has been answered, in the order the questionnaire asks them, with
//its answer as lines of text. People questions (BIRTHDAY, REGISTER) give a line per person.
//A question with no answer is left out, so the dialog only shows what was actually said.
export function questionAnswersOn(booking: any): { question: string, lines: string[] }[] {
  const questions: any[] = booking?.questionnaire?.bookingquestions ?? [];

  return [...questions]
    .sort((first, second) => (Number(first.listorder) || 0) - (Number(second.listorder) || 0))
    .map(question => ({ question: (question.questiontext ?? "").toString().trim(), lines: answerLines(question) }))
    .filter(item => item.question != "" && item.lines.length > 0);
}

function answerLines(question: any): string[] {
  const answers = question?.answers;

  if (answers == null) {
    return [];
  }

  const text = (value: any): string => (value ?? "").toString().trim();

  switch ((question.questiontype ?? "").toString().toUpperCase()) {
    case "FREETEXT":
      return text(answers.freetextanswer) != "" ? [text(answers.freetextanswer)] : [];

    case "NUMBER":
    case "AGE":
      return answers.numberanswer != null && text(answers.numberanswer) != "" ? [text(answers.numberanswer)] : [];

    case "DATE": {
      const date = answerDate(answers.dateanswer);
      return date != "" ? [date] : [];
    }

    case "MULTICHOICESINGLE":
      return text(answers.multichoicesingleanswer?.listitemtext) != "" ? [text(answers.multichoicesingleanswer.listitemtext)] : [];

    case "MULTICHOICEMULTIPLE": {
      const chosen = (answers.multichoicemultianswer ?? []).map(item => text(item?.listitemtext)).filter(item => item != "");
      return chosen.length > 0 ? [chosen.join(", ")] : [];
    }

    case "ALLERGY": {
      const allergy = answers.allergyanswer;

      if (allergy == null || allergy.allergypresent == null) {
        return [];
      }

      return allergy.allergypresent
        ? ["Yes" + (text(allergy.allergytext) != "" ? " - " + text(allergy.allergytext) : "")]
        : ["No"];
    }

    case "BIRTHDAY":
    case "REGISTER":
      return (answers.birthdayanswers ?? [])
        .map(person => {
          const parts = [
            text(person.age) != "" ? "age " + text(person.age) : "",
            answerDate(person.birthdate),
            text(person.gender),
            text(person.interests)
          ].filter(part => part != "");

          const name = text(person.name);

          return name != "" && parts.length > 0 ? name + " (" + parts.join(", ") + ")" : (name != "" ? name : parts.join(", "));
        })
        .filter(line => line != "");

    default:
      return text(answers.freetextanswer) != "" ? [text(answers.freetextanswer)] : [];
  }
}

//A date answer as dd/MM/yyyy, read as written (dates are held as wall clock with a Z on the end).
//Nothing for an empty one or the 1900 placeholder.
function answerDate(value: any): string {
  if (value == null || value === "") {
    return "";
  }

  const date = new Date(value);

  if (isNaN(date.getTime()) || date.getUTCFullYear() <= 1900) {
    return "";
  }

  return ('00' + date.getUTCDate()).slice(-2) + '/' + ('00' + (date.getUTCMonth() + 1)).slice(-2) + '/' + date.getUTCFullYear();
}
